import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { usersEmailChange } from '../mockData/users-data';

const UsersApi = [rest.patch(`${API_ROOT}users/${usersEmailChange.id}`, (req, res, ctx) => res(ctx.json({ data: usersEmailChange })))];
export default UsersApi;
